export default __webpack_public_path__ + "static/idacatering-13f1191ee7407963f8c925f6537c0db5.png";